import { Droppable } from 'react-beautiful-dnd'
import { type TaskDomain } from '../../../../types/domain/task-domain'
import { Card } from './Card'

type Props = {
  title: string
  id: string
  tasks: any
  isDropDisabled?: boolean
  onTaskClick: (task: TaskDomain) => void
}

export const Column = ({
  title,
  id,
  tasks,
  isDropDisabled = false,
  onTaskClick,
}: Props) => {
  return (
    <div className="w-[221px]">
      <div className="bg-primary-light py-3 px-4 rounded-[10px] mb-2 sticky z-50 top-0">
        <p className="text-sm font-medium text-white ">{title}</p>
      </div>

      <Droppable droppableId={id} isDropDisabled={isDropDisabled}>
        {(provided) => (
          <div
            className="flex flex-col gap-2 h-full rounded-[10px] mb-4"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {tasks?.map((task: any, index: number) => (
              <Card
                onTaskClick={onTaskClick}
                task={task}
                index={index}
                key={task.id}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </div>
  )
}
